import React from 'react'
import classnames from 'classnames'
import { JSONTreeWrapped } from '../json-tree'

import Render from './views'
import ShowHide from './views/show-hide'

const RecordDisplay = ({ record, level1 = [], level2 = [], inactive = false, showRaw = false }) => (
  <div
    title={inactive ? 'This record is inactive' : null}
    className={classnames({
      'recordDisplay--wrapper': true,
      'recordDisplay--wrapper__inactive': inactive,
      'inactiveRecord': inactive
    })}>
    <Render record={record} keys={level1} />

    {
      level2.length > 0 ?
        <ShowHide>
          <Render record={record} keys={level2} />

          {
            showRaw ?
              <ShowHide label="raw government record">
                <JSONTreeWrapped data={record} />
              </ShowHide> :
              null
          }
        </ShowHide>
        : null
    }
  </div>
)

export {
  ShowHide
}

export default RecordDisplay



// WEBPACK FOOTER //
// ./src/ui/record-display/index.jsx